"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeFilename = void 0;
const illegalRe = /[/?<>\\:*|"]/g;
// eslint-disable-next-line no-control-regex
const controlRe = /[\x00-\x1f\x80-\x9f]/g;
const reservedRe = /^\.+$/;
const windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;
const windowsTrailingRe = /[. ]+$/;
/**
 * Cross-platform safe filename normalisation.
 * From https://www.npmjs.com/package/sanitize-filename
 */
function safeFilename(input, maxLength = 100) {
    const sanitized = input
        .replace(illegalRe, "")
        .replace(controlRe, "")
        .replace(reservedRe, "")
        .replace(windowsReservedRe, "")
        .replace(windowsTrailingRe, "");
    return sanitized.slice(0, maxLength);
}
exports.safeFilename = safeFilename;
